// extracted by mini-css-extract-plugin
module.exports = {"wrap":"footer-module--wrap--18kOD","sns":"footer-module--sns--2WHLf"};